import { render, staticRenderFns } from "./HostingKvmSsh.vue?vue&type=template&id=2378bbb2&scoped=true&"
import script from "./HostingKvmSsh.vue?vue&type=script&lang=js&"
export * from "./HostingKvmSsh.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmSsh.vue?vue&type=style&index=0&id=2378bbb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2378bbb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2378bbb2')) {
      api.createRecord('2378bbb2', component.options)
    } else {
      api.reload('2378bbb2', component.options)
    }
    module.hot.accept("./HostingKvmSsh.vue?vue&type=template&id=2378bbb2&scoped=true&", function () {
      api.rerender('2378bbb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmSsh.vue"
export default component.exports